import { createGlobalStyle } from 'styled-components'
import reset from './reset'
import grid from './grid'
import typography from './typography'
import { Config } from '../../config'

// https://www.digitalocean.com/community/tutorials/css-system-font-stack
export const GlobalStyles = createGlobalStyle`
  ${reset}
  ${grid(Config)}
  ${typography(Config)}
  * {
    box-sizing: border-box;
  }
  /* HTML5 hidden-attribute fix for newer browsers */
  *[hidden] {
      display: none;
  }
  html {
    font-size: 62.5%;
    max-width: 100vw;
    overflow-x: hidden;
  }
  body{
    font-family:'Halvetica','Helvetica Neue','Farfetch Basis','arial','sans-serif';
    -moz-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    text-size-adjust: 100%;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    position: relative;
    & .react-toast-notifications__container {
      max-width: 100%;
    }
  }

  [data-blogger] {
    font-family:'Halvetica','Helvetica Neue','Farfetch Basis','arial', 'sans-serif';
    font-weight: bold !important;
    font-style: normal;
  }

  input, button {
    background-color: transparent;
    border: none;
    outline: none;
  }

  /* TEMP: toast container */
  .react-toast-notifications__container {
    z-index: 99999 !important;
  }

  /* fix safari zoom on input focus */
  @media screen and (-webkit-min-device-pixel-ratio:0) { 
    select,
    textarea,
    input {
      font-size: 16px!important;
    }
  }
`
